
import { usePartner } from '@/context/PartnerContext'
import { Stack, Text } from '@chakra-ui/react'
import { faLock } from '@fortawesome/pro-light-svg-icons'
import { AuthPageLayout } from 'BrokerTsLib/src/components'

export const PoleasClientDisabled = () => {
    const { currentPartner } = usePartner()

    return (
        <AuthPageLayout
            title="Nabídka je uzamčena"
            titleIcon={faLock}
            logo={currentPartner?.logo}
        >
            <Stack maxW={'45ch'} mx={'auto'} gap={4}>
                <Text fontSize={'xl'} textAlign={'center'}>
                    V nejbližší době Vás budeme telefonicky kontaktovat.
                </Text>

                <Text fontSize={'xl'} textAlign={'center'}>
                    Pokud se Vám nedovoláme, nebo nás chcete kontaktovat dříve, můžete volat naše klientské centrum na čísle <strong>844 11 33 55</strong>.
                </Text>
            </Stack>
        </AuthPageLayout>
    )
}